
import { Row, Col, Input, Button, Modal, Checkbox, Upload, Table, Image, Form, Tag, Popover, Select, notification } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, FileImageOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { fetchData, sendData, sendDataPut } from '../../httpRequests';
import AddAdsToPharmacy from './AddAdsToPharmacy';
const { Search } = Input;

const { Option } = Select;
const form = {
    name: '',
    nameb: '',
    website: '',
    category_id: null,
    pharmacies_id: null,
    img: ""
}
const editAds = (
    <small>
        Edit
    </small>
);
const deleteAds = (
    <small>
        Delete
    </small>
);
const activeAds = (
    <div>
        <small>Si desactiva este anuncio no estara disponoble para mostrarse.</small>
    </div>
);
export default function Ads() {

    const [isModalVisibleCreateAds, setIsModalVisibleCreateAds] = useState(false);
    const [formValues, setFormValues] = useState(form)
    const [filteredAds, setFilteredAds] = useState([]);
    const [filteredAdsName, setFilteredAdsName] = useState([]);
    const [categorys, setCategorys] = useState([]);
    const [categorysInput, setCategorysInput] = useState([]);
    const [fharmacies, setFharmacies] = useState([]);
    // const [img, setImg] = useState(null)
    const [tbLoading, setTbLoading] = useState(false)
    const [seeImgInput, setSeeImgInput] = useState(null);
    const [validarImg, setValidarImg] = useState(false)
    const [modoEdit, setModoEdit] = useState(true)
    const [idUpdateAds, setIdUpdateAds] = useState(0)

    const { website, name, nameb, category_id, pharmacies_id, img } = formValues

    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    }

    const getAds = () => {
        const url = '/advertisements/ads';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const ads = response['ads'];
                setFilteredAds(ads)
                setFilteredAdsName(ads)
            }
        })

    }
    const getCategoty = () => {
        const url = '/categories/getCategories';
        fetchData(url).then(async(response) => {
            if (Object.keys(response).length > 0) {
                const categories = await response['category'];
                let allCategory = categories
                allCategory.unshift({ id: 0, name: 'All' })
                setCategorys(allCategory)
               
            }
        })
    }
    const getCategotyfilter = () => {
        const url = '/categories/getCategories';
        fetchData(url).then(async(response) => {
            if (Object.keys(response).length > 0) {
                const categories = await response['category'];
                setCategorysInput(categories)
               
            }
        })
    }

    const getFharmacies = () => {
        const url = '/pharmacies/getPharmacies';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const farmacies = response['pharmacy'];
                let allFarmcy = farmacies
                allFarmcy.unshift({ id: 0, name: 'All' })
                setFharmacies(allFarmcy)
            }
        })
    }

    const handleFilter = (e) => {
        setFormValues({
            ...formValues,
            category_id: e
        })
    }

    const handleFilterPhamacies = (e) => {
        setFormValues({
            ...formValues,
            pharmacies_id: e,
            category_id: null,
            nameb: ''
        })

        if (e == 0) {
            getAds()
        } else {
            const filtetFarmacy = filteredAds.filter((ads) => {
                return ads.id_pharmacy == e
            })
            setFilteredAdsName(filtetFarmacy);

        }

    }

    useEffect(() => {
        getAds()
        getCategoty()
        getFharmacies()
        getCategotyfilter()
    }, [])
    useEffect(() => {
        console.log('ok')
        if (seeImgInput != null) {
            seeFileProduct()
        }
    }, [seeImgInput])

    const handleCancel = () => {
        setIsModalVisibleCreateAds(false)
        setSeeImgInput(null)
        setValidarImg(false)
        setIdUpdateAds(0)
    }

    const seeFileProduct = async () => {
        console.log(seeImgInput)
        if (seeImgInput.target.files[0] != undefined) {
            const image = document.getElementById("image-selected1");
            const image2 = document.getElementById("image-selected");
            const reader = new FileReader();
            reader.readAsDataURL(seeImgInput.target.files[0]);
            reader.onload = (seeImgInput) => {
                seeImgInput.preventDefault();
                image.setAttribute('src', seeImgInput.target.result)
                image2.setAttribute('src', seeImgInput.target.result)
                image.removeAttribute("width")
                image.removeAttribute("height")

                image.onload = () => {
                    var ancho = image.width;
                    var alto = image.height
                    if (ancho != 900 || alto != 500) {
                        console.log('no cumple')
                        setValidarImg(true)
                    } else {
                        setValidarImg(false)
                    }
                }
            }

        } else {
            setSeeImgInput(null)
        }
    }
    const showModalCreateAds = () => {
        setIsModalVisibleCreateAds(true)
        setModoEdit(true)
        const form = {
            name: '',
            nameb: '',
            website: '',
            category_id: null,
            pharmacies_id: null,
            img: ""
        }
        setFormValues(form)

    }

    const saveAds = () => {
        const id = localStorage.getItem('PHARMACY_LOGGED')

        const url = '/advertisements/ads';
        const url2 = `/advertisements/updateAds/${idUpdateAds}`;
        const data = {
            pharmacy_id: id,
            website,
            name,
            category_id

        };
        if (modoEdit) {
            sendData(url, data).then(async (response) => {
                if (response.ok) {
                    if (seeImgInput != null && seeImgInput != undefined) {
                        await handleFile(response.ads.id)
                    }
                    getAds()
                    openNotificationWithIcon('success', 'Ads added successfully')
                    setIsModalVisibleCreateAds(false)
                } else {
                    console.log('data')
                }
            })
        } else {

            // console.log('editado')
            sendDataPut(url2, data).then(async (response) => {
                console.log(response)
                if (response.ok) {
                    if (seeImgInput != null && seeImgInput != undefined) {
                        await handleFile(idUpdateAds)
                    }
                    getAds()
                    openNotificationWithIcon('success', response.msg)
                    handleCancel()
                }


            })
        }

    }

    const activeDisable = async (id, status) => {
        setTbLoading(true)

        const url = `/advertisements/activeDisable/ads/${id}`;
        const data = {
            status: status ? false : true
        };
        sendData(url, data).then(async (response) => {
            if (response.ok) {
                let b = await filteredAds.findIndex(res => {
                    return res.id == response.ads.id
                })
                if (status == true) {
                    filteredAds[b].status = false
                    filteredAdsName[b].status = false
                } else {
                    filteredAds[b].status = true
                    filteredAdsName[b].status = true
                }
                setTbLoading(false)
            }

        })
    }
    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };
    const columns = [
        {
            title: 'NAME',
            render: ({ id, status, img, website, name }) => (
                <div>
                    {name}
                </div>
            )
        },
        {
            title: 'IMG',
            render: ({ img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={img} />
                </div>
            )
        },
        {
            title: 'SITIO WEB',
            render: ({ id, status, img, website }) => (
                <div>
                    <a href={website}>{website}</a>
                </div>
            )
        },
        {
            title: 'PHARMACY',
            dataIndex: 'pharmacy_name',
            key: 'pharmacy_name',
        },
        {
            title: 'CATEGORY',
            dataIndex: 'category_name',
            key: 'category_name',
        },
        {
            title: 'STATUS',
            render: ({ id, status, img }) => (
                <div style={{ cursor: 'pointer' }}>
                    {
                        (status == true)
                            ? <Popover content={activeAds} trigger="hover">
                                <Tag color="green" onClick={() => activeDisable(id, status)}>Active</Tag>
                            </Popover>
                            : <Tag color="volcano" onClick={() => activeDisable(id, status)}>Disabled</Tag>
                    }
                </div>
            )
        },


        {
            title: 'ACTION',
            render: ({ id, img, name, website, category_id, pharmacies_id }) => (
                <div style={{ display: 'flex' }} onClick={() => showModalEditar(id, img, name, website, category_id, pharmacies_id)}>
                    <Popover content={editAds} trigger="hover">
                        <span style={{ margin: 10, cursor: 'pointer' }}>
                            <EditOutlined style={{ fontSize: '25px', color: '#128780' }} />
                        </span>
                    </Popover>

                    <Popover content={deleteAds} trigger="hover">
                        <span style={{ margin: 10, cursor: 'pointer' }}  >
                            <DeleteOutlined style={{ fontSize: '25px', color: 'red' }} />
                        </span>
                    </Popover>
                </div>

            )
        },

    ];
    // edit
    const showModalEditar = (id, img, name, website, category_id, pharmacies_id) => {
        setIdUpdateAds(id)
        const form = {
            name,
            website,
            category_id,
            pharmacies_id,
            img
        }

        setFormValues(form)
        setModoEdit(false)
        setIsModalVisibleCreateAds(true)
    }
    // img file
    const handleFile = async (id) => {
        let cloudurl = (window.location.hostname.includes('localhost'))
            ? `http://localhost:3001/api/advertisements/updatePhotoAds/ads/${id}`
            : `https://coopharma-api-zd5is.ondigitalocean.app/api/advertisements/updatePhotoAds/ads/${id}`

        let file = seeImgInput.target.files[0]
        const formData = new FormData();
        formData.append('image', file);
        try {
            const resp = await fetch(cloudurl, {
                method: 'post',
                body: formData
            });

            if (resp.ok) {
                const cloudResp = await resp.json();
                setSeeImgInput(null)
            }
        } catch (error) {
            console.log(error, "error")
        }
    }
    // buscador
    const onSearch = (value) => {
        let text = value.target.value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        setFormValues({
            ...formValues,
            nameb: text,
            pharmacies_id: null,
            category_id: null
        })

        if (text) {
            const filteredAdsName = filteredAds.filter((ads) => {
                return ads.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().includes(text)
            });
            setFilteredAdsName(filteredAdsName);
        } else {
            setFilteredAdsName(filteredAds);
        }
    }

    const handleFilterCategory = (e) => {
        setFormValues({
            ...formValues,
            pharmacies_id: null,
            nameb: '',
            category_id: e
        })

        if (e == 0) {
            getAds()
        } else {
            const filterCategorys = filteredAds.filter((category) => {
                return category.category_id == e
            })
            setFilteredAdsName(filterCategorys);
        }
    }
    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Col span={6}>
                    <Search
                        size='large'
                        placeholder='Search name'
                        onChange={onSearch}
                        name="nameb"
                        value={nameb}
                    />
                </Col>
                <Col span={5}>
                    <Select
                        style={{ width: '100%' }}
                        showSearch
                        optionFilterProp="children"
                        size='large'
                        name="pharmacies_id"
                        value={pharmacies_id}
                        onChange={handleFilterPhamacies}
                        placeholder='Pharmacy'
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {fharmacies.map((c) => (
                            <Option key={c.id} value={c.id}  >
                                {c.name}
                            </Option>
                        ))
                        }
                    </Select>
                </Col>
                <Col span={5}>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        style={{ width: '100%' }}
                        size='large'
                        name="category_id"
                        value={category_id}
                        onChange={handleFilterCategory}
                        placeholder='Categories'
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                        {categorys.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
                <Col span={4}>
                    <Button
                        onClick={showModalCreateAds}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        {/* <PlusOutlined /> */}
                        Create Ads
                    </Button>
                </Col>
                <Col span={4}>
                    <AddAdsToPharmacy />
                </Col>
            </Row>
            {/* Modal crear ads */}
            <Modal title={modoEdit ? "Create ads" : 'Edit ads'}
                visible={isModalVisibleCreateAds}
                onCancel={handleCancel}
                width={600}
                footer={null}
                closable={true}
            >
                <Row gutter={24}>
                    <Col span={24} className='formMarginInput'>
                        <Form
                        >
                            <Col span={24}>

                                <label htmlFor="" ><b style={{ color: 'red' }}>*</b> <b>Select Image</b></label>
                                <div className='bordereFile' style={{ marginTop: "10px" }}>
                                    <div className='file-select'>
                                        <div className='drag'>
                                            <div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <FileImageOutlined style={{ fontSize: '32px', color: 'white' }} />
                                                </div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <b style={{ fornSize: '17px', color: 'white' }}>Add Image</b>
                                                </div>
                                                <p style={{ color: 'white' }}>or drag and drop</p>
                                            </div>
                                        </div>
                                        <input type="file" onChange={(e) => setSeeImgInput(e)} accept="jpeg" />
                                    </div>

                                </div>
                                <b> La imagen tiene que tener una dimensión de 900 * 500</b>

                            </Col>
                            <Col span={24} style={{ display: 'none' }}>
                                <img src="" alt="" id="image-selected1" style={{ marginTop: "10px", borderRadius: 20 }} />
                            </Col>
                            <Col span={24} >
                                {(validarImg) ? <small style={{ color: 'red' }}>Esta Imagen no cumple con la dimensión requerida</small> : <small></small>}
                                {(seeImgInput != null) ? <img src={img} height='180' width="60%" alt="" id="image-selected" style={{ marginTop: "10px", borderRadius: 20 }} /> : <div></div>}
                                {(img != '' && seeImgInput == null) ? <img src={img} height='180' width="60%" alt="" id="image-selected" style={{ marginTop: "10px", borderRadius: 20 }} /> : <div></div>}

                            </Col>
                            <Col span={24} className='formMarginInput'>
                                <label htmlFor=""><span style={{ color: 'red' }}>*</span>Name</label>
                                <Input
                                    type='text'
                                    size='large'
                                    name="name"
                                    value={name}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col span={24} className='formMarginInput'>
                                <label htmlFor="">Sitio web</label>
                                <Input
                                    type='url'
                                    size='large'
                                    name="website"
                                    value={website}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col span={24} className='formMarginInput'>
                                <label htmlFor=""><span style={{ color: 'red' }}>*</span>Categoria</label>
                                <Select style={{ width: '100%' }} size='large' name="category_id" value={category_id} onChange={handleFilter}>
                                    {categorysInput.map((c) => (
                                        <Select.Option key={c.id} value={c.id}  >
                                            {c.name}
                                        </Select.Option>
                                    ))
                                    }
                                </Select>

                            </Col>

                            <Col span={24}>
                                {(modoEdit) ? <Button
                                    htmlType="submit"
                                    onClick={saveAds}
                                    type='primary'
                                    size='large'
                                    style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                                    disabled={seeImgInput == null || name == '' || category_id == null || validarImg == true}
                                >
                                    <SaveOutlined />
                                    Save
                                </Button> : <Button
                                    htmlType="submit"
                                    onClick={saveAds}
                                    type='primary'
                                    size='large'
                                    style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                                    disabled={ name == '' || category_id == null || validarImg == true}
                                >
                                    <SaveOutlined />
                                    Save edit
                                </Button>}

                            </Col>
                        </Form>

                    </Col>


                </Row>



            </Modal>
            <Table columns={columns} dataSource={filteredAdsName} rowKey={(item) => item.id}
                loading={tbLoading} />
        </div>
    )
}